import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  title: {
    fontSize: '1rem',
    fontWeight: 'bold',
    lineHeight: '1.5'
  },
  textField: {
    width: '100%',
    '& .MuiFormHelperText-contained': {
      margin: '0 !important'
    }
  }
}));
